import { Box, Button, Chip, Divider, Grid, Typography } from "@mui/material";
import { useRef, useContext, useState, useEffect } from "react";
import { appLogger } from "../../../utils";
import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import RatingCountChart from "./ratingChart";


interface IProps {
    details: any;
    rating: any;
    closeRating: any;
    categoriesValue: any;
    setIsMailEditor: any;
    setNewMessage: any;
}

interface IRating {
    startupRating: number[];
    freezeRating: number[];
    layerRating: number[];
}

const AnalyticsDetails = (props: IProps) => {
    appLogger.info({ infoObj: { method: "AnalyticsDetails", component: "mailing", fileName: "analyticsDetails.tsx", props: props } });
    const inputFile: any = useRef(null);
    const { userInfo } = useContext(UserContext) as UserLoginInfo;
    // const [rating, setRating] = useState({});
    // const [closeRating, setcloseRating] = useState({});
    // const [categoriesValue, setCategoryValue] = useState<number[]>([]);


    const {
        details, rating, closeRating, categoriesValue, setIsMailEditor, setNewMessage
    } = props;



    const handleEdit = () => {
        setIsMailEditor(true);
    };

    const showDefaultResponse = () => {
        if (closeRating["closeStartup"] <= 6) {
            const msg = "We have some known system issues, apologies. Please try again in an hour. Your next movie is ad free on us.";
            setNewMessage(msg);
            return msg;
        }
        if (closeRating["closeFreeze"] <= 6) {
            const msg = "Connect to better wifi or come closer to the wifi. Or too many people on the same wifi. Or poor connection. Time to upgrade your line";
            setNewMessage(msg);
            return msg;
        }
        if (closeRating["closeLayer"] <= 6) {
            const msg = "Connect to better wifi or come closer to the wifi. Or too many people on the same wifi. Or poor connection. Time to upgrade your line";
            setNewMessage(msg);
            return msg;
        }
        return false;
    };

    return (
        <Box sx={{ width: "100%", padding: "10px", backgroundColor: "#fff" }}>
            <Grid container>
                <Grid item xs={12}>
                    {showDefaultResponse() &&
                        <>
                        <Divider sx={{ my: 2 }} />
                            <Typography sx={{
                                // position: "absolute",
                                width: "95px",
                                height: "17px",
                                fontFamily: 'Poppins',
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "11px",
                                lineHeight: "16px",
                                color: "#202124",
                                opacity: "0.8"
                            }}>
                                Default response
                            </Typography>
                            <br></br>
                            <Grid container spacing={2}>
                                <Grid item xs={10}>
                                    <Box
                                        sx={{
                                            boxSizing: 'border-box',
                                            // position: 'absolute',
                                            width: '482px',
                                            height: '55px',
                                            background: 'rgba(40, 88, 211, 0.1)',
                                            border: '1px solid #2858D3',
                                            borderRadius: '100px',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                // position: 'absolute',
                                                width: '448px',
                                                height: '36px',
                                                fontFamily: 'Poppins',
                                                fontStyle: 'normal',
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                lineHeight: '18px',
                                                color: '#2858D3',
                                                padding: "10px"
                                            }}
                                        >
                                            {showDefaultResponse()}
                                        </Typography>
                                    </Box>
                                    {/* <Chip sx={{
                                height: 'auto',
                                '& .MuiChip-label': {
                                    display: 'block',
                                    whiteSpace: 'normal',
                                },
                            }} label="Your network is experiencing buffering issues. This is because your usage exceeds the capacity of your Wi-Fi." color="primary" variant="outlined" /> */}
                                </Grid>
                                <Grid item>
                                    {/* <Typography sx={{
                                        // position: "absolute",
                                        width: "34px",
                                        height: "18px",
                                        fontFamily: 'Poppins',
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        lineHeight: "18px",
                                        color: "#202124",
                                        opacity: 0.8
                                    }}>&nbsp;&nbsp;&nbsp;00:09</Typography> */}
                                    {/* <br></br> */}
                                    <Button sx={{
                                        // position: "absolute",
                                        width: "30px",
                                        height: "21px",
                                        fontFamily: 'Poppins',
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        lineHeight: "21px",
                                        color: "#2242F5"
                                    }} onClick={handleEdit}>EDIT</Button>
                                </Grid>
                            </Grid>
                        </>

                    }
                    <br></br>
                    <Divider sx={{ my: 2 }} />

                    {/* <Typography sx={{ pt: 1 }} className="info">
                        Select to add optional fields
                    </Typography>
                    <Typography className="no-data">
                        no data
                    </Typography>
                    <Divider />
                    <Typography sx={{ pt: 1 }} className="info">
                        CuVo Automate metadata
                    </Typography>
                    <Typography className="no-data">
                        no data
                    </Typography>
                    <Divider /> */}
                    <Typography sx={{
                        // position: "absolute",
                        width: "37px",
                        height: "17px",
                        fontFamily: 'Poppins',
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "11px",
                        lineHeight: "16px",
                        color: "#202124",
                        opacity: "0.8"
                    }}>
                        Report
                    </Typography>
                    {/* <Typography className="title-sm-fb">
                        Freeze frequency rating: {details["bpAnalyticsDetails"] ? details["bpAnalyticsDetails"][0]["freeze_frequency_rating"] : null}
                    </Typography>
                    <Typography className="title-sm-fb">
                        Layer rating: {details["bpAnalyticsDetails"] ? details["bpAnalyticsDetails"][0]["layer_rating"] : null}
                    </Typography>
                    <Typography className="title-sm-fb">
                        Startup rating: {details["bpAnalyticsDetails"] ? details["bpAnalyticsDetails"][0]["startup_rating"] : null}
                    </Typography>
                    <Divider /> */}
                    <RatingCountChart
                        startupRatingData={rating && rating.startupRating}
                        freazeRatingData={rating && rating.freezeRating}
                        layerRatingData={rating && rating.layerRating}
                        categoriesValue={categoriesValue}
                        ticketArrival={details["createdOn"]}
                        userDetails={details["userDetails"]} />
                </Grid>

            </Grid>
        </Box >
    );
};

export default AnalyticsDetails;
